import { SharedModule } from './../../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RescueApplicationComponent } from './rescue-application/rescue-application.component';
import { RescueComponent } from './rescue.component';
import { NgxMaskModule } from 'ngx-mask';
import { MatRadioModule } from '@angular/material';
import { SignatureComponent } from '../../../shared/signature/signature.component';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RescueResultComponent } from './rescue-result/rescue-result.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		NgxMaskModule.forRoot(),
		MatRadioModule,
		CurrencyMaskModule,
		FormsModule,
		ReactiveFormsModule
	],
	declarations: [
		RescueApplicationComponent,
		RescueComponent,
		RescueResultComponent
	],
	exports: [
		RescueComponent
	]
})
export class RescueModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/rescue/rescue.module.ts